<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout wrap align-center justify-center>
      <v-card v-if="show" class="mx-auto" max-width="500" outlined>
        <v-card-title>{{ $t('auth.welcome') }}</v-card-title>
        <v-card-text>
          <div v-if="isExpired">
            <div class="mb-3">
              El link de invitación a la plataforma ya expiró, si ya creaste tu contraseña puedes iniciar sesión en la plataforma.
            </div>
            <div>
              <v-btn
                text
                color="primary"
                to="/login">
                Ir a iniciar sesión
              </v-btn>
            </div>
          </div>
          <div v-else>
            <div v-if="hasPassword">
              <div>
                <v-btn :disabled="!form.acceptedTOS" color="success" @click="login">Accept invitation</v-btn>
              </div>
              <div>
                <v-checkbox color="primary" v-model="form.acceptedTOS">
                  <template v-slot:label>
                    <div>
                      <span>
                        Aceptar
                      </span>
                      <a @click.stop class="primary--text" href="https://docs.google.com/document/d/1Te9qJSArXl5YExlTpDzEl_sipAAZXC1DSyc5fJ8uP-I/edit" target="_blank">términos y condiciones</a>
                    </div>
                  </template>
                </v-checkbox>
              </div>
            </div>
            <v-form v-else v-model="isValid">
              <v-container grid-list-xl>
                <v-layout wrap>
                  <v-flex xs12 md12>
                    <div>
                      <v-text-field
                        v-model="form.password"
                        :rules="rules.password"
                        :label="$t('auth.labels.password')"
                        counter
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        required
                      ></v-text-field>
                    </div>
                    <div>
                      <v-checkbox color="primary" v-model="form.acceptedTOS">
                        <template v-slot:label>
                          <div>
                            <span>
                              Aceptar
                            </span>
                            <a @click.stop class="primary--text" href="https://docs.google.com/document/d/1Te9qJSArXl5YExlTpDzEl_sipAAZXC1DSyc5fJ8uP-I/edit" target="_blank">términos y condiciones</a>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-btn :disabled="!form.acceptedTOS" color="success" @click="login">{{ $t('auth.labels.acceptInvitation') }}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {

  name: 'AcceptInvitation',

  computed: {
    version () {
      return process.env.VUE_APP_VERSION
    }
  },

  async mounted () {
    await this.$store.dispatch('logout')
    if (this.$route.query.provider) {
      this.$store.commit('setUserprovider')
      this.form.userprovider = true
    }
    try {
      const response = await this.$api.get(`/v1/invitations/${this.$route.params.id}`)
      this.form.email = response.email
      this.hasPassword = response.hasPassword
    } catch (error) {
      if (error.status && (error.status === 404 || error.status === '404')) {
        this.isExpired = true
      } else {
        this.$toasted.error(error.message, { duration: 3000 })
      }
    }
    this.show = true
  },

  data () {
    return {
      show: false,
      hasPassword: false,
      isExpired: false,
      isValid: false,
      showPassword: false,
      form: {
        email: null,
        password: null,
        userprovider: false,
        acceptedTOS: false
      },
      rules: {
        password: [
          v => !!v || this.$t('validations.password')
        ]
      }
    }
  },

  methods: {
    async login () {
      try {
        const response = await this.$api.post(
          `/v1/invitations/${this.$route.params.id}/accept`,
          {
            email: this.form.email,
            password: this.form.password || '',
            userprovider: this.form.userprovider,
            acceptedTOS: this.form.acceptedTOS
          }
        )

        this.$store.commit('login/setToken', response.jwt)
        this.$store.commit('login/user/set', response.user)
        this.$store.commit('setVersion', this.version)

        await this.$store.dispatch('login/loadLoginData')

        if (this.form.userprovider) {
          this.$router.push({ name: 'SelectProvider' })
        } else {
          this.$router.push({ name: 'SelectRestaurant' })
        }

        this.$toasted.success('Welcome to Eato', { duration: 3000 })
      } catch (e) {
        this.$toasted.error(e.message, { duration: 3000 })
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
